export const extractDescription = (htmlString) => {
    // Create a new DOM parser
    const parser = new DOMParser();
    // Parse the HTML string into a document
    const doc = parser.parseFromString(htmlString, 'text/html');
    // Find the div containing the description
    const descriptionDiv = doc.querySelector('div > div');
    // Return the text content of the div
    return descriptionDiv ? descriptionDiv.textContent : null;
}